<template>
  <div class="container anim-course-dialog" @mousedown.stop="handleMouseDownComp()" @click.stop>
    <div
      class="backdrop"
      v-show="visible"
      :style="{width: Window_Size.width + 'px',height: Window_Size.height + 'px'}"
    ></div>

    <transition name="slide-fade">
      <div
        class="main"
        v-show="visible"
        :style="{
          width: dialogSize.width + 'px',
          height: dialogSize.height + 'px',
          left: dialogSize.left + 'px',
          top: dialogSize.top + 'px'
        }"
      >
        <div class="stage-enter" v-show="stage === 'enter'">
          <div class="title-area">
            <!-- <div class="sub-title">新/手/必/学</div> -->
            <!-- <div class="title">3分钟快速上手来画工具</div> -->
            <div class="title">{{currCourse.title}}</div>
            <div class="after-title">（新手必看）</div>
          </div>
          <div class="btn-area">
            <div class="btn btn-start" @click="handleBtnStart()">开始</div>
            <div class="btn btn-more" @click="handleBtnMore()">更多教程</div>
            <div class="btn btn-exit" @click="close()">退出</div>
          </div>
        </div>
        <div class="video-wrapper" :class="{ghost: stage !== 'anim'}">
          <video
            :data-course-id="currCourse.id"
            :src="$handleAssetsUrl(currCourse.url)"
            :style="{
              width: dialogSize.width + 'px',
              height: dialogSize.height + 'px',
            }"
            @ended="onVideoEnded()"
            @timeupdate="timeUpdate($event)"
            class="video"
            preload="auto"
            ref="videoRef"
            v-if="currCourse"
            v-show="currId > -1"
          ></video>
          <div
            class="anchor"
            v-show="anchorShow"
            :style="{left: currPos[0] + '%', top: currPos[1] + '%'}"
            @click="play($refs.videoRef)"
          >
            <div class="spinner spinner-4"></div>
            <div class="spinner spinner-6"></div>
            <div class="pop-msg" :class="{'in-right': isMsgInRight}" v-show="currMsg">
              <span class="pop-msg-inner">
                <span style="display: block;" v-for="(v, i) in textToArr(currMsg)" :key="i">{{v}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="stage-exit" v-show="stage === 'exit'">
          <div class="title-area">
            <div class="title">你已成功完成学习！</div>
            <div class="after-title">现在就开始制作视频吧(*^▽^*)</div>
          </div>
          <div class="btn-area">
            <div class="btn btn-more ml0" @click="handleBtnMore()">更多教程</div>
            <div class="btn btn-exit" @click="close()">关闭</div>
          </div>
        </div>

        <div class="close-wrapper" @click.stop="close()">
          <div class="close icon-popup-close"></div>
        </div>

        <div class="step-btns" v-show="stage === 'anim'">
          <div class="step-btn" :class="{disabled: stepPreviousDisabled}" @click="stepPrevious">上一步</div>
          <div class="step-btn" :class="{disabled: stepNextDisabled}" @click="stepNext">下一步</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    visible: Boolean
  },
  data() {
    return {
      courses: [],
      currId: -1,
      stepIndex: 0,
      progress: 0,
      canPlayThroughDone: false,
      currPos: [],
      currMsg: "",
      anchorShow: true,
      stage: "enter", // enter anim exit
      isMsgInRight: false,
      stageExitDelay: null
    };
  },
  computed: {
    ...mapGetters(["Window_Size", "TOOL"]),
    dialogSize() {
      // let width = Math.min(1280, this.Window_Size.width - 88);
      // let height = Math.min(720, this.Window_Size.height - 50);
      let width = 1000;
      let height = 562.5;
      let left = (this.Window_Size.width - width) / 2;
      let top = (this.Window_Size.height - height) / 2;
      return {
        width,
        height,
        left,
        top
      };
    },
    currCourse() {
      let ret = {};
      this.courses.some(c => {
        let flag = c.id === this.currId;
        if (flag) {
          ret = c;
          return flag;
        }
      });
      return ret;
    },
    stepNextDisabled () {
      return this.currCourse && this.currCourse.data && this.stepIndex >= this.currCourse.data.length - 1;
    },
    stepPreviousDisabled () {
      return this.stepIndex <= 0;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.reset();
      } else {
        this.$refs.videoRef.pause();
        this.anchorShow = false;
      }
    }
  },
  created() {
    this.$bus.on("openCourseById", courseId => {
      this.currId = courseId;
      this.reset();
    });
    this.$bus.on("getApiCourse", this.getApiCourse);
  },
  mounted() {},
  methods: {
    setStep (num) {
      if (this.stage !== 'anim') return;
      this.stepIndex = num;
      const el = this.$refs.videoRef;
      if (!el) return;
      const steps = this.currCourse.data;
      const previousStep = steps[this.stepIndex - 1];
      const progress = previousStep ? previousStep.duration : 0;
      $(el).off('pause');
      el.pause();
      el.currentTime = progress;
      this.updateCurrPos();
    },
    stepNext () {
      if (this.stepIndex >= this.currCourse.data.length - 1) {
        return;
      }
      this.setStep(this.stepIndex + 1);
    },
    stepPrevious () {
      if (this.stepIndex <= 0) {
        return;
      }
      this.setStep(this.stepIndex - 1);
    },
    getApiCourse() {
      this.$http.get(`/api/common/course?type=1`).then(res => {
        let courses = res.data.data || [];
        let sorted = courses.sort((a, b) => a.sort - b.sort);
        this.courses = sorted;
        let mapped = sorted.map(v => {
          // let m = 0;
          // v.data.forEach(v => {
          // m += v.duration;
          // v.timing = m;
          // });
          return { title: v.title, id: v.id };
        });
        if (courses.length > 0) {
          this.currId = courses[0].id;
        }
        this.$bus.emit("animCourse.getTitles", mapped);
      });
    },
    reset(stageName = "enter") {
      clearTimeout(this.stageExitDelay);
      this.stage = stageName;
      this.stepIndex = 0;
      this.progress = 0;
      this.canPlayThroughDone = false;
      this.anchorShow = stageName === "enter";
      let videoEl = this.$refs.videoRef;
      if (videoEl) {
        videoEl.pause();
        videoEl.currentTime = 0;
      }
    },
    close() {
      this.$store.commit("save_TopnavMsg", {
        isShowAnimCourseDialog: false
      });
    },
    play(el, end) {
      let currStep = this.currCourse.data[this.stepIndex] || {};
      this.$analysis(
        `hover_botton,click_course_${this.currCourse.id}_${currStep.id},悬浮按钮_点击_${this.currCourse.id}_${currStep.id}`
      );
      el.volume = 0.8;
      el.play().then(() => {
        this.anchorShow = el.paused;
      });
    },
    // canPlayThrough (ev) {
    // let el = ev.currentTarget;
    // if (!this.canPlayThroughDone) {
    //   this.updateCurrPos();
    //   this.canPlayThroughDone = true;
    // }
    // },
    timeUpdate(ev) {
      let el = ev.currentTarget;
      if (el.paused) {
        return;
      }
      let steps = this.currCourse.data;
      let progress = steps[this.stepIndex].duration; // timing
      if (el.currentTime >= progress - 0.2) {
        $(el).on("pause", () => {
          $(el).off("pause");
          el.currentTime = progress;
          this.stepIndex += 1;
          if (this.stepIndex >= this.currCourse.data.length) {
            this.stageExitDelay = setTimeout(() => {
              this.endCourse();
            }, 2500);
          } else {
            this.anchorShow = el.paused;
            this.updateCurrPos();
          }
        });
        try {
          el.pause();
        } catch (e) {
          console.log("timeUpdate -> e", e);
        }
      }
    },
    updateCurrPos() {
      let currStep = this.currCourse.data[this.stepIndex] || {};
      if (!currStep.handCord) {
        return [];
      }
      // let posArr = currStep.handCord.replace(/[^\,\.0-9]/g, '').split(',');
      let posArr = currStep.handCord.match(/(\d+\.?\d+)\D+(\d+\.?\d+)/) || [];
      if (posArr.length >= 2) {
        posArr = posArr.slice(1, 3);
      }
      this.currPos = posArr;
      this.currMsg = currStep.title;
      this.updateMsgPos(posArr);
    },
    updateMsgPos(posArr) {
      let w = this.dialogSize.width;
      let l = (w * posArr[0]) / 100;
      this.isMsgInRight = l < 215;
    },
    handleBtnStart() {
      this.reset();
      this.updateCurrPos();
      this.stage = "anim";
      this.$analysis(
        "hover_botton,click_course_begin,悬浮按钮_点击_教程_开始学习"
      );
    },
    handleBtnMore() {
      let link = document.createElement("a");
      link.href = "/college/guide";
      link.target = "_blank";
      link.click();
      this.$analysis(
        "hover_botton,click_course_more,悬浮按钮_点击_教程_更多教程"
      );
    },
    handleMouseDownComp() {
      this.$bus.emit("FeaturesPop_close_vue", {
        type: 3
      });
    },
    endCourse() {
      this.stage = "exit";
      this.reset("exit");
    },
    onVideoEnded() {
      this.stageExitDelay = setTimeout(() => {
        this.endCourse();
      }, 2500);
    },
    textToArr(text = "") {
      return text.replace(/\/n|\\n/g, ",").split(",");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./const.scss";
@import "../../../style/_triangle.scss";

.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(#39393c, 0.8);
}
.main {
  position: absolute;
  top: 25px;
  left: 44px;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 8px;
  & > .step-btns {
    position: absolute;
    top: calc(100% + 32px);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .step-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 168px;
      height: 46px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 4px;
      cursor: pointer;
      margin-left: 19px;
      margin-right: 19px;
      &.disabled {
        color: #B8B9BF;
        background: #EBECF2;
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-80%);
  opacity: 0;
}

.video-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 8px;
  background-color: #000;

  &.ghost {
    width: 0;
    height: 0;
    overflow: hidden;
    opacity: 0;
  }
}
.video {
  // width: 1280px;
  // height: 720px;
  border-radius: 8px;
  max-width: none;
}
.anchor {
  position: absolute;
  top: 0;
  left: 0;
  width: 54px;
  height: 54px;
  transform: translate(-50%, -50%);
  cursor: pointer;

  & > .pop-msg {
    $w: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: -15px - $w;
    top: 50%;
    transform: translatey(-50%);
    width: $w;
    min-height: 43px;
    background-color: #5778FB;
    border-radius: 6px;
    box-sizing: border-box;

    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #ffffff;

    // &::after {
    //   // content: " ";
    //   position: absolute;
    //   left: 100%;
    //   top: 50%;
    //   transform: translate(-1px, -50%);
    //   @include triangle(right, 15px, 12px, #5778FB);
    // }
  }

  & > .pop-msg.in-right {
    left: 54px;
    // &::after {
    //   left: 1px;
    //   transform: translate(-100%, -50%);
    //   @include triangle(left, 15px, 12px, #5778FB);
    // }
  }

  & .pop-msg-inner {
    line-height: 22px;
    padding: 12px 18px;
  }
}

// spinner
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  // margin-left: -.1em;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: #5778FB;
}

.spinner-4:after,
.spinner-4:before,
.spinner-6:after,
.spinner-6:before {
  position: absolute;
  left: 50%;
  margin-top: -1.5em;
  margin-left: -1.5em;
  opacity: 0;
  background: #5778FB;
}

.spinner:after,
.spinner:before {
  display: block;
  width: 3em;
  height: 3em;
  content: "";
  border-radius: 50%;
}

.spinner-4:after,
.spinner-4:before {
  top: 50%;
  -webkit-animation: pulserip 2s linear infinite;
  animation: pulserip 2s linear infinite;
}

.spinner-4:after {
  -webkit-animation: pulserip 2s linear 0.5s infinite;
  animation: pulserip 2s linear 0.5s infinite;
}

.spinner-6:after,
.spinner-6:before {
  top: 50%;
  -webkit-animation: pulserip 2s linear 1s infinite;
  animation: pulserip 2s linear 1s infinite;
}

.spinner-6:after {
  -webkit-animation: pulserip 2s linear 1.5s infinite;
  animation: pulserip 2s linear 1.5s infinite;
}

@-webkit-keyframes pulserip {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }

  to {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
    opacity: 0;
  }
}

@keyframes pulserip {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }

  to {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
    opacity: 0;
  }
}

.stage-enter,
.stage-exit {
  padding-top: 120px;
  background-color: #504bf5;
  height: 100%;
  border-radius: 8px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.stage-enter {
  background-image: url("../../../../static/img/anim-course/103.1-1.png");
}

.stage-exit {
  background-image: url("../../../../static/img/anim-course/103.2-1.png");
}

.title-area {
  & .sub-title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 1px;
    color: #ffffff;
    text-align: center;
    text-indent: -392px;
  }
  & .title {
    padding: 0 20px;
    font-size: 46px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 58px;
    letter-spacing: 2px;
    color: #ffffff;
    text-align: center;
  }

  & .after-title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #ffffff;
    text-align: center;
    padding-top: 20px;
  }
}

.btn-area {
  margin-top: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn {
  width: 161px;
  height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 1px;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  &-start {
    background-image: url($btn-bgi-1);
    color: #0800ff;
  }

  &-more {
    margin-left: 45px;
    background-image: url($btn-bgi-2);
    color: #fff;
  }

  &-exit {
    margin-left: 45px;
    background-image: url($btn-bgi-3);
    color: #fff;
  }

  &-start:hover {
    background-image: url($btn-bgi-1-1);
    color: #0800ff;
  }

  &-more:hover {
    margin-left: 45px;
    background-image: url($btn-bgi-2-1);
    color: #fff;
  }

  &-exit:hover {
    margin-left: 45px;
    background-image: url($btn-bgi-3-1);
    color: #fff;
  }
  &.ml0 {
    margin-left: 0;
  }
}

.ml0 {
  margin-left: 0;
}

.close-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: calc(100% + 4px);
  top: -14px;
  // transform: translateX(12px);
  width: 28px;
  height: 28px;
  // background-image: url($close);
  // background-repeat: no-repeat;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  background: #fff;

  // &:hover {
  //   background-image: url($close-hover);
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/animCourse/animCourseDialog.vue